import { useGetFundAssets } from '@/queries/fund';
import { IFundAsset } from '@/services/apis/fund/types';

interface IUseFindFundAssetByFundCodeReturn {
  fundAsset: IFundAsset | undefined;
  isLoading: boolean;
}

export const useFindFundAssetByFundCode = (
  fundCode: string | undefined,
  shouldIncludeZeroCount: boolean = false
): IUseFindFundAssetByFundCodeReturn => {
  const { data, isLoading } = useGetFundAssets({
    enabled: !!fundCode,
  });

  const fundAsset = data?.assetOnFunds?.find(
    (asset) =>
      asset.fundCode === fundCode &&
      (shouldIncludeZeroCount || asset.count !== 0)
  );

  return { fundAsset, isLoading };
};
